export default {
    ja: {
        footer: {
            banner: {
                image: 'Images/logo/japan-heritage_logo-type.png',
                link: '',
                title: '',
                description: '石川県小松市に所在する那谷寺は、日本遺産「石の文化」の構成文化財の１つ。那谷寺の名所・奇岩遊仙境と呼ぶ独特な石の風景が広がります。江戸時代には松尾芭蕉も訪れ、この風景を詠んだ句が「おくのほそ道」にも残されています。',
            }
        }
    },
    en: {
        footer: {
            banner: {
                image: 'Images/logo/japan-heritage_logo-type.png',
                link: '',
                title: '',
                description: 'Natadera Temple, located in Komatsu City, Ishikawa Prefecture, is one of the cultural assets that make up the Japan Heritage site "Culture of Stone." \n' +
                    'The temple is renowned for its unique stone landscape known as Kigan Yūsenkyō, or "The Rock Garden of Spiritual Immersion." In the Edo period, the famous haiku poet Matsuo Basho visited Natadera, and he composed a verse about this landscape, which is included in his travel diary "The Narrow Road to the Deep North."',
            }
        }
    },


}